import type * as ents from '@attain-apps/entities'

import type { Feature } from './feature'

export class Selectors {
  /**  TODO: Explain */
  public readonly lookup

  /** Entity id projected form lastly added entry to {@link entries}. Represents currently upserted record */
  public readonly editedEntityId

  /**  Record projected from lastly added entry to {@link entries}. Represents currently upserted record  */
  public readonly editedRecord

  /**  Lastly added entry to {@link entries}. Represents currently upserted record */
  public readonly editedEntry

  /**  List of edited entity ids projected from {@link entries} */
  public readonly editedEntityIds

  /**  Array of {@link ents.core.dms.data.Record Records} and {@link ents.core.dms.models.Entity.Id entity ids} to be added from last to first */
  public readonly entries

  /**  TODO: Explain */
  public readonly getRecords
  /**  TODO: Explain */
  public readonly getRecord
  /**  TODO: Explain */
  public readonly isLoading
  /**  TODO: Explain */
  public readonly getError

  constructor(feature: Feature) {
    this.lookup = feature.state.project(state => state.lookup)
    this.entries = feature.state.project(state => state.entries)
    this.editedEntityIds = feature.state.project(state =>
      state.entries.map(entry => entry.entityId),
    )
    this.editedEntry = this.entries.project(
      entries => entries[entries.length - 1],
    )
    // NOTE: if entries is an empty array, editedEntry will be undefined, so we
    // actually need ? on both lines
    this.editedEntityId = this.editedEntry.project(entry => entry?.entityId)
    this.editedRecord = this.editedEntry.project(entry => entry?.record)

    this.getRecords = feature.createSelectorMethod(
      ({
        entityId,
        // NOTE:  Add more query  params if needed
      }: ExactlyOneOf<{ entityId: ents.core.dms.models.Entity.Id }>) =>
        this.lookup.project(lookup => lookup[entityId]?.records ?? [])
          .asSelector,
    )
    this.getRecord = feature.createSelectorMethod(
      ({
        entityId,
        recordId,
      }: {
        entityId: ents.core.dms.models.Entity.Id
        recordId: ents.core.dms.data.Record.Id
      }) =>
        this.getRecords({ entityId }).project(records =>
          records.find(record => record.id === recordId),
        ),
    )

    this.isLoading = feature.createSelectorMethod(
      ({
        entityId,
        entity,
      }: ExactlyOneOf<{
        entityId: ents.core.dms.models.Entity.Id
        entity: ents.core.dms.models.Entity
      }>) => {
        entityId ??= entity?.id
        if (entityId === undefined) {
          throw new Error('Either entity or entityId must be provided')
        }

        return this.lookup
          .project(lookup => lookup[entityId])
          .project(member => member?.loading ?? false).asSelector
      },
    )

    this.getError = feature.createSelectorMethod(
      ({
        entityId,
        entity,
      }: ExactlyOneOf<{
        entityId: ents.core.dms.models.Entity.Id
        entity: ents.core.dms.models.Entity
      }>) => {
        entityId ??= entity?.id
        if (entityId === undefined) {
          throw new Error('Either entity or entityId must be provided')
        }
        return this.lookup
          .project(lookup => lookup[entityId])
          .project(member =>
            member?.error instanceof Error ? member?.error.message : undefined,
          ).asSelector
      },
    )
  }
}
